/**
 * Canonical responsive breakpoints.
 * Use in CSS via @media (min-width: ...) — mobile-first.
 * Use in JS for programmatic breakpoint checks.
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type Breakpoint = keyof typeof breakpoints;
